import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';

import { Modal, Button } from 'antd';

import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import refundService from 'v2/services/requestManagement/refund';

export default function ApproveMotive() {
  const [open] = useObservable(() => refundService.getMassApprove(), []);
  const [refunds] = useObservable(() => refundService.list(), []);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const close = useCallback(() => {
    refundService.closeMassApprove();
  }, []);

  const [onSubmit] = useCallbackObservable(() => {
    setSubmitting(true);
    const checkedRefunds: string[] = (refunds || [])
      .filter(r => r.checked)
      .map(r => {
        return r.id;
      });
    return refundService.massApprove(checkedRefunds).pipe(
      tap(() => {
        setSubmitting(false);
        refundService.closeMassApprove();
        toast.success('Solicitações aprovadas com sucesso!');
      }),
      catchError(err => {
        setSubmitting(false);
        toast.error(err);
        return of(true);
      })
    );
  }, [refunds]);

  const quantity = (refunds || []).filter(r => r.checked).length;

  return (
    <Modal
      open={open}
      width={600}
      title='Aprovar Reembolso'
      onCancel={close}
      footer={
        <div className='flex justify-end gap-2'>
          <Button onClick={close} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button type='primary' loading={isSubmitting} disabled={isSubmitting} onClick={onSubmit}>
            Aprovar Reembolso
          </Button>
        </div>
      }
      closable
    >
      Deseja aprovar <b>{quantity}</b> solicitações de reembolso ?
    </Modal>
  );
}
